<template>
  <div>
    <h5 style="display:none;">Admin footer</h5>   
  </div>
</template>

<script>
  export default {
  }
</script>

<style scoped>

</style>
